import type { ScriptTuple } from '@features/third-party-scripts/types/ScriptTuple.ts';

export const PRODUCTION_SCRIPTS = (domainData: SNDomainData): (false | ScriptTuple)[] => [
  domainData.venueName === 'sn' && {
    position: 'append',
    target: 'head',
    scriptMarkup: `
      <!-- Google Tag Manager -->
      <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-KJ6KVKV8');</script>
      <!-- End Google Tag Manager -->
    `,
  },
  domainData.venueName === 'sn' && {
    position: 'prepend',
    target: 'body',
    scriptMarkup: `
      <!-- Google Tag Manager (noscript) -->
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KJ6KVKV8"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <!-- End Google Tag Manager (noscript) -->
    `,
  },
  domainData.venueName === 'cgg' && {
    position: 'append',
    target: 'head',
    scriptMarkup: `
        <!-- Google Tag Manager -->
        <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PNGB4JNT');</script>
        <!-- End Google Tag Manager -->
    `,
  },
  domainData.venueName === 'cgg' && {
    position: 'prepend',
    target: 'body',
    scriptMarkup: `
      <!-- Google Tag Manager (noscript) -->
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PNGB4JNT"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <!-- End Google Tag Manager (noscript) -->
    `,
  },
  domainData.venueName === 'stt' && {
    position: 'append',
    target: 'head',
    scriptMarkup: `
      <!-- Google Tag Manager -->
      <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-5KHTCZTZ');</script>
      <!-- End Google Tag Manager -->
    `,
  },
  domainData.venueName === 'stt' && {
    position: 'prepend',
    target: 'body',
    scriptMarkup: `
      <!-- Google Tag Manager (noscript) -->
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5KHTCZTZ"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <!-- End Google Tag Manager (noscript) -->
    `,
  },
  domainData.venueName === 'sn' && {
    position: 'append',
    target: 'head',
    scriptMarkup: `
    <script type="text/javascript">
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "v29fasfg37");
    </script>
    `,
  },
  domainData.venueName === 'cgg' && {
    position: 'append',
    target: 'head',
    scriptMarkup: `
    <script type="text/javascript">
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "v29hmngvnm");
    </script>
    `,
  },
  domainData.venueName === 'stt' && {
    position: 'append',
    target: 'head',
    scriptMarkup: `
    <script type="text/javascript">
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "v29i8gom0a");
    </script>
    `,
  },
];
